/**
 * 관리 화면 날짜·시간 표기(2026-09-15). 서버는 ISO 문자열을 준다 — 없거나 깨진 값은 "—" 로 통일한다
 * (빈칸이면 "값이 없다" 와 "화면이 깨졌다" 를 구분할 수 없다).
 */

/** 없음 표기. */
export const NONE = '—';

/** ISO → 사용자 로캘 날짜·시각. */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return NONE;
  }
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? NONE : d.toLocaleString();
}

/**
 * 시작~종료 사이의 길이. 종료가 없으면(진행 중) **지금까지**의 길이를 준다.
 * 사람이 읽는 단위로만 쓴다(시간·분 / 분·초 / 초) — 감사 목적이라 초 단위 정밀도는 긴 세션에서 소음이다.
 */
export function fmtDuration(startIso: string | null | undefined, endIso: string | null | undefined): string {
  if (!startIso) {
    return NONE;
  }
  const start = new Date(startIso).getTime();
  const end = endIso ? new Date(endIso).getTime() : Date.now();
  if (Number.isNaN(start) || Number.isNaN(end)) {
    return NONE;
  }
  const total = Math.max(0, Math.round((end - start) / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) {
    return `${h}시간 ${m}분`;
  }
  if (m > 0) {
    return `${m}분 ${s}초`;
  }
  return `${s}초`;
}
